import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импорт JSON-файлов переводов
import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';
import translationKK from './locales/kk/translation.json';

const resources = {
  en: { translation: translationEN },
  ru: { translation: translationRU },
  kk: { translation: translationKK },
};

i18n
  .use(LanguageDetector) // Подключаем автоопределение языка
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Язык по умолчанию
    supportedLngs: ['en', 'ru', 'kk'],
    
    // ВАЖНО: Эта настройка заставляет i18next игнорировать регион (ru-RU -> ru)
    load: 'languageOnly',

    // Настройка детектора языка
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React сам экранирует XSS
    },
  });

export default i18n;